const svgFiles = require.context('./icons', true, /\.svg$/);
svgFiles.keys().map((item) => svgFiles(item));
